export const OrderStatus = {
  Success: 'выполнен',
  InProgress: 'в работе',
  Created: 'создан',
};
